import "./lib/jquery.fitvids.js";
import "./infinite-scroll.js";
import "./kw-nav.js";
import "./kw-form.js";
import "./kw-validation.js";
import "./kw-sendsay-popup.js";
import "./kw-blog.js";

(() => {
  // FitVids - Makes video embeds responsive
  // NOTE: не уверен что оно вообще нужно, и кажется только оно jquery тащит
  // Какой-то jquery плагин для видео "fluid width video embeds" https://fitvidsjs.com/
  $(".gh-content").fitVids();

  // copy - paste from landing
  // меню Продукт

  const insideSubmenuButton = document.querySelector(".kw-submenu-button");
  if (insideSubmenuButton) {
    insideSubmenuButton.onclick = () => {
      const menu = insideSubmenuButton.closest(".kw-site-header-menu");
      if (menu) {
        menu.classList.toggle("open");
      }
    };
  }

  const scrollClass = "scroll";
  const header = document.querySelector("header div.header");
  function onScroll() {
    if (header) {
      window.requestAnimationFrame(() => {
        if (window.scrollY > 50) {
          header.classList.add(scrollClass);
        } else {
          header.classList.remove(scrollClass);
        }
      });
    }
  }
  onScroll();
  window.addEventListener("scroll", onScroll);

  const kwBtnUp = document.querySelector(".kw-btn-up");
  if (kwBtnUp) {
    kwBtnUp.onclick = () => {
      window.scrollTo({
        behavior: "smooth",
        top: 0,
      });
    };
    window.addEventListener(
      "scroll",
      () => {
        if (window.scrollY > 100) {
          kwBtnUp.classList.add("show");
        } else {
          kwBtnUp.classList.remove("show");
          kwBtnUp.blur();
        }
      },
      {
        passive: true,
      },
      false,
    );
  }
})();
